import { Action } from '@reduxjs/toolkit';
import { Customer } from 'services/resources';
import { PublicDealershipSettings } from './types';
import { FailureActionTypes } from 'services/utilityTypes';

const PUBLIC_ACTION_BASE = 'app/services/Public/';

export enum PublicActionTypes {
  UPDATE_CUSTOMER_SUCCESS = PUBLIC_ACTION_BASE + 'UPDATE_CUSTOMER_SUCCESS',
  UPDATE_CUSTOMER_FAIL = PUBLIC_ACTION_BASE + 'UPDATE_CUSTOMER_FAIL',
  GET_CUSTOMER_SUCCESS = PUBLIC_ACTION_BASE + 'GET_CUSTOMER_SUCCESS',
  GET_CUSTOMER_FAIL = PUBLIC_ACTION_BASE + 'GET_CUSTOMER_FAIL',
  CREATE_CUSTOMER_DOCUMENT_SUCCESS = PUBLIC_ACTION_BASE + 'CREATE_CUSTOMER_DOCUMENT_SUCCESS',
  CREATE_CUSTOMER_DOCUMENT_FAIL = PUBLIC_ACTION_BASE + 'CREATE_CUSTOMER_DOCUMENT_FAIL',
  GET_DEALERSHIP_SETTINGS_SUCCESS = PUBLIC_ACTION_BASE + 'GET_DEALERSHIP_SETTINGS_SUCCESS',
  GET_DEALERSHIP_SETTINGS_FAIL = PUBLIC_ACTION_BASE + 'GET_DEALERSHIP_SETTINGS_FAIL',
}

type PublicFailureActionTypes = FailureActionTypes<PublicActionTypes>;

interface PublicActionBase extends Action {
  type: PublicActionTypes;
  payload: Record<string, unknown>;
}

interface CustomerFailureAction extends PublicActionBase {
  type: PublicFailureActionTypes;
  payload: { errors: any };
}

interface CustomerUpdateAction extends PublicActionBase {
  type: PublicActionTypes.UPDATE_CUSTOMER_SUCCESS;
  payload: Record<string, never>;
}

interface CustomerGetAction extends PublicActionBase {
  type: PublicActionTypes.GET_CUSTOMER_SUCCESS;
  payload: { customer: Customer };
}

interface CustomerDocumentCreateAction extends PublicActionBase {
  type: PublicActionTypes.CREATE_CUSTOMER_DOCUMENT_SUCCESS;
  payload: Record<string, never>;
}

interface DealershipSettingsGetAction extends PublicActionBase {
  type: PublicActionTypes.GET_DEALERSHIP_SETTINGS_SUCCESS;
  payload: { dealershipSettings: PublicDealershipSettings };
}

interface DealershipSettingsFailureAction extends PublicActionBase {
  type: PublicActionTypes.GET_DEALERSHIP_SETTINGS_FAIL;
  payload: { errors: any };
}

export type PublicAction =
  | CustomerUpdateAction
  | CustomerGetAction
  | CustomerDocumentCreateAction
  | CustomerFailureAction
  | DealershipSettingsGetAction
  | DealershipSettingsFailureAction;

export const receivedUpdateCustomerSuccess = (): PublicAction => ({
  type: PublicActionTypes.UPDATE_CUSTOMER_SUCCESS,
  payload: {},
});

export const receivedUpdateCustomerFail = (errors: any): CustomerFailureAction => ({
  type: PublicActionTypes.UPDATE_CUSTOMER_FAIL,
  payload: { errors },
});

export const receivedCustomerSuccess = (customer: Customer): CustomerGetAction => ({
  type: PublicActionTypes.GET_CUSTOMER_SUCCESS,
  payload: { customer },
});

export const receivedCustomerFail = (errors: any): CustomerFailureAction => ({
  type: PublicActionTypes.GET_CUSTOMER_FAIL,
  payload: { errors },
});

export const receivedPostCustomerDocumentSuccess = (): CustomerDocumentCreateAction => ({
  type: PublicActionTypes.CREATE_CUSTOMER_DOCUMENT_SUCCESS,
  payload: {},
});

export const receivedPostCustomerDocumentFail = (errors: any): CustomerFailureAction => ({
  type: PublicActionTypes.CREATE_CUSTOMER_DOCUMENT_FAIL,
  payload: { errors },
});

export const receivedDealershipSettingsSuccess = (
  dealershipSettings: PublicDealershipSettings
): DealershipSettingsGetAction => ({
  type: PublicActionTypes.GET_DEALERSHIP_SETTINGS_SUCCESS,
  payload: { dealershipSettings },
});

export const receivedDealershipSettingsFail = (errors: any): DealershipSettingsFailureAction => ({
  type: PublicActionTypes.GET_DEALERSHIP_SETTINGS_FAIL,
  payload: { errors },
});
